import type { FC } from 'react';
import { observer } from 'mobx-react-lite';
import clsx from 'clsx';
import { Body1 } from '@sbol/nova';
import BubbleExclamationImg from './bubble_exclamation.svg?react';
import styles from './Toast.module.scss';

export const Toast: FC<{ className?: string | null; text?: string | null }> = observer(({ className, text }) => {
  return (
    <div className={clsx(styles.Toast, className)}>
      <BubbleExclamationImg className={styles.Toast_icon} />
      <Body1 className={styles.Toast_text}>{text}</Body1>
    </div>
  );
});
